import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';
import { Option } from '../../../inputs/select/options';
import { CreateEventForm } from '../../types';
import { OrganizationsService } from '../../../../services/organizations.service';
import { EventsHttpService } from '../../../../services/events.http.service';
import { DateTimeService } from '../../../../services/date-time.service';
import { TranslateService } from '../../../../services/translate.service';

@Component({
  selector: 'app-event-management-basic-info',
  templateUrl: './event-management-basic-info.component.html',
  styleUrls: ['./event-management-basic-info.component.scss'],
})
export class EventManagementBasicInfoComponent implements OnInit {
  public organizationOptions: Option[] = [];
  public eventStatusOptions: Option[] = [];
  public eventShortDescriptionMaxLength = 100;

  @Input() innerForm: FormGroup<CreateEventForm>;
  @Input() id: string;

  get eventShortDescriptionCharactersLeft(): number {
    const charactersLeft =
      this.eventShortDescriptionMaxLength -
      (this.innerForm.controls.event_short_description.value?.length ?? 0);

    return charactersLeft < 0 ? 0 : charactersLeft;
  }

  get eventStatusDescription(): string {
    const { value } = this.innerForm.controls.event_status_id;

    return value
      ? TranslateService.translate(`status_${value}_description`)
      : '';
  }

  constructor(
    private organizationsService: OrganizationsService,
    private eventsHttpService: EventsHttpService,
    private cdr: ChangeDetectorRef
  ) {
    this.organizationsService.getOrganizations().subscribe((organizations) => {
      this.organizationOptions = organizations.data.map((org) => ({
        id: org.organization_id,
        itemName: org.organization_name,
      }));

      this.cdr.detectChanges();
    });

    this.eventsHttpService.getStatuses().subscribe(({ statuses }) => {
      this.eventStatusOptions = statuses.map((item) => ({
        id: item.id,
        itemName: TranslateService.translate(`status_${item.id}`),
      }));

      this.cdr.detectChanges();
    });
  }

  ngOnInit(): void {
    this.innerForm.controls.event_short_description.addValidators(
      Validators.maxLength(this.eventShortDescriptionMaxLength)
    );
  }

  get minEventFinishDate(): NgbDateStruct | undefined {
    let eventStartDate: string =
      this.innerForm.controls.event_start_date.getRawValue();

    if (!eventStartDate) {
      return undefined;
    }

    return DateTimeService.dateToNgbDateStruct(
      DateTimeService.adjustDateForTimezone(eventStartDate)
    );
  }
}
